export const getPriceCurrencySymbol = (priceFormat: string) => {
  return priceFormat.replace(/[0-9,.]/g, '')
}

export const getWithCurrencySymbol = (priceFormat: string, price: number): string => {
  const priceWithDecimal = getWithDecimal(price)
  const priceFormatCurrencyPosition = Number(priceFormat[0])
  const currencySymbol = getPriceCurrencySymbol(priceFormat)
  return Number.isInteger(priceFormatCurrencyPosition)
    ? formatPrice(priceFormat, priceWithDecimal) + currencySymbol
    : currencySymbol + formatPrice(priceFormat, priceWithDecimal)
}

export const formatPrice = (priceFormat: string, price: string): string => {
  const decimalFormat = (/\B(?=(\d{3})+(?!\d))/g)
  const decimalTypeCount = (priceFormat.match(/[.]/g) || []).length
  return decimalTypeCount === 1
    ? price.replace(decimalFormat, ',')
    : price.replace('.', ',')
      .replace(decimalFormat, '.')
}

export const getWithDecimal = (price: number): string => {
  return (price / 100).toFixed(2)
}
